import React from 'react';
import { jsx, css } from '@emotion/core';
import chroma from 'chroma-js';

import Link from '../../../Link/Link';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { ImPhone } from 'react-icons/im';

import './Services.scss';

const Services = ({
  services,
  primaryColor,
  secondaryColor,
  datiFarmacia,
  footerVersion,
}) => {
  const servicesStyle = css`
    &.variant-1,
    &.variant-2 {
      background-color: ${chroma(secondaryColor)
        .darken(0.4)
        .hex()};

      .boxes {
        .service-box {
          background-color: ${chroma(secondaryColor)
            .brighten(0.2)
            .hex()};
        }
      }
    }

    &.variant-3 {
      background-color: ${chroma(primaryColor)
        .darken(0.3) //precedente: darken(2)
        .hex()};

      .boxes {
        .service-box {
          background-color: ${chroma(primaryColor)
            .brighten(0.2) //precendente: .darken(0.7)
            .hex()};
        }
      }
    }
  `;
  return (
    <div
      className={`services-container variant-${footerVersion}`}
      css={servicesStyle}
    >
      <div className="boxes">
        {services.map((service, index) => {
          if (index > 1) return null;
          return service.action ? (
            <div key={service.id} className={`service-box left-side-${index}`}>
              <a href={service.action} className="service">
                {service.icon}
                <span className="sub-title">{service.title}</span>
              </a>
            </div>
          ) : (
            <div key={service.id} className={`service-box left-side-${index}`}>
              <Link to={service.url} className="service">
                {service.icon}
                <span className="sub-title">{service.title}</span>
              </Link>
            </div>
          );
        })}

        {services.map((service, index) => {
          return (
            index > 1 && (
              <div
                key={service.id}
                className={`service-box right-side-${index}`}
              >
                <Link to={service.url} className="service">
                  {service.icon}
                  <span className="sub-title">{service.title}</span>
                </Link>
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

export default Services;
